import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronDown, FaQuestionCircle } from "react-icons/fa";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: "Where is Dr. Sainulabid's IQRA Multispeciality Dental Clinic located?",
      answer:
        "Dr. Sainulabid's IQRA Multispeciality Dental Clinic is located near PMSA Yatheemkhana, Kattilangadi, Athavanad, Kerala - 676301. We welcome patients from Athavanad, Pattarnadakavu, Thirunavaya, Puthanathani, Valanchery, Kuttippuram and nearby areas."
    },
    {
      question: "What dental treatments do you provide at IQRA Multispeciality Dental Clinic?",
      answer:
        "We provide Root Canal Treatment, Dental Implants, Hollywood Smile Design, Teeth Whitening, Cosmetic Dentistry, Teeth Cleaning & Scaling, Braces & Aligners, Tooth Extraction, Children's Dentistry, Gum Treatment, Crowns & Bridges, Dentures and complete family dental care."
    },
    {
      question: "Do I need to book an appointment before visiting?",
      answer:
        "Appointments are recommended to avoid waiting time. You can book your appointment by phone or WhatsApp. Walk-in patients are also welcome, subject to availability."
    },
    {
      question: "What are the working hours of Dr. Sainulabid's IQRA Multispeciality Dental Clinic?",
      answer:
        "Our clinic is open Monday to Saturday from 09:00 AM to 07:30 PM. We remain closed on Sundays."
    },
    {
      question: "Do you provide painless dental treatment?",
      answer:
        "Yes. We use modern dental technology and advanced techniques to provide comfortable and painless dental treatments whenever possible."
    },
    {
      question: "Do you treat children at your clinic?",
      answer:
        "Yes. Our clinic provides gentle and friendly dental care for children including routine check-ups, fillings, preventive treatments and oral hygiene guidance."
    },
    {
      question: "Do you provide braces and teeth alignment treatment?",
      answer:
        "Yes. We provide orthodontic treatments including metal braces, ceramic braces and aligner consultations to help improve your smile and bite."
    },
    {
      question: "Can I visit from nearby towns?",
      answer:
        "Absolutely. Many of our patients visit us from Athavanad, Pattarnadakavu, Thirunavaya, Puthanathani, Valanchery, Kuttippuram and surrounding areas in Malappuram district."
    },
    {
      question: "How can I contact IQRA Multispeciality Dental Clinic?",
      answer:
        "You can call us directly at +91 85903 00370 or book an appointment through WhatsApp from our website. Our team will assist you with appointments, treatment details and consultation timings."
    },
    {
      question: "Why choose Dr. Sainulabid's IQRA Multispeciality Dental Clinic?",
      answer:
        "Dr. Sainulabid's IQRA Multispeciality Dental Clinic combines experienced doctors, advanced technology, affordable treatment, patient-friendly care and a modern multispeciality approach to provide quality dental care for every member of your family."
    },
    {
      question: "Do you provide emergency dental treatment?",
      answer:
        "Yes. We provide emergency dental care for severe tooth pain, dental injuries, infections and other urgent dental problems. Please call us before visiting so we can assist you as quickly as possible."
    },
    {
      question: "Do you accept patients of all ages?",
      answer:
        "Yes. We provide comprehensive dental care for children, adults and senior citizens, making us a family-friendly multispeciality dental clinic."
    }
  ];

  return (
    <section id="faq" className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-white to-[#F8FBFC] relative overflow-hidden">
      
      <div className="absolute inset-0">
        <motion.div
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
          className="absolute -top-40 -left-40 w-80 h-80 bg-teal-100/30 rounded-full blur-3xl"
        />
        <motion.div
          animate={{ scale: [1, 1.3, 1], opacity: [0.2, 0.4, 0.2] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut", delay: 1 }}
          className="absolute -bottom-40 -right-40 w-96 h-96 bg-teal-50/40 rounded-full blur-3xl"
        />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto">

        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50/80 backdrop-blur-sm px-4 py-2 rounded-full mb-4 border border-teal-100">
            <span className="w-1.5 h-1.5 bg-teal-500 rounded-full animate-pulse"></span>
            <FaQuestionCircle className="text-teal-600 text-sm" />
            <span className="text-teal-600 text-xs sm:text-sm font-semibold tracking-wide">
              FREQUENTLY ASKED QUESTIONS
            </span>
            <span className="w-1.5 h-1.5 bg-teal-500 rounded-full animate-pulse"></span>
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1E293B] mb-4">
            Frequently Asked{" "}
            <span className="bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] bg-clip-text text-transparent">
              Questions
            </span>
          </h2>

          <div className="w-24 h-1 bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] mx-auto rounded-full"></div>

          <p className="text-gray-500 text-sm sm:text-base mt-5 max-w-2xl mx-auto">
            Everything you need to know about Dr. Sainulabid's IQRA Multispeciality Dental Clinic.
          </p>
        </div>

        <div className="space-y-4 sm:space-y-5">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100/50 overflow-hidden"
            >
              <button
                onClick={() =>
                  setActiveIndex(activeIndex === index ? null : index)
                }
                className="w-full flex justify-between items-center text-left p-5 sm:p-6 hover:bg-teal-50/30 transition-colors duration-200 group"
              >
                <h3 className="text-sm sm:text-base md:text-lg font-semibold text-[#1E293B] pr-4 group-hover:text-teal-600 transition-colors">
                  {faq.question}
                </h3>

                <motion.div
                  animate={{
                    rotate: activeIndex === index ? 180 : 0
                  }}
                  transition={{ duration: 0.3 }}
                  className="flex-shrink-0 w-8 h-8 rounded-full bg-teal-50 flex items-center justify-center group-hover:bg-teal-100 transition-colors"
                >
                  <FaChevronDown className="text-teal-600 text-sm" />
                </motion.div>
              </button>

              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-gray-600 text-sm sm:text-base leading-7 sm:leading-8">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-12 sm:mt-16 text-center"
        >
          <p className="text-gray-600 text-sm sm:text-base">
            Have more questions? Contact our friendly team today.
          </p>

          <a
            href="#contact"
            className="inline-block mt-4 sm:mt-5 bg-gradient-to-r from-[#2CA6B1] to-[#4FD1C5] text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-xl font-semibold hover:scale-105 transition duration-300 shadow-lg"
          >
            Book an Appointment
          </a>
        </motion.div>

      </div>
    </section>
  );
}